var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"flexible-work-shift-status",class:`flexible-work-shift-status--${_setup.status.toLowerCase()}`},[_c('font-awesome-icon',{staticClass:"flexible-work-shift-status__icon mr-1",attrs:{"icon":[_vm.light ? 'fal' : 'far', _setup.statusIcon]}}),_vm._v(" "+_vm._s(_setup.statusText)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }